import { Box, IconButton, Typography, useMediaQuery } from "@mui/material";
import Slider from "react-slick";
import { useEffect, useState } from "react";
import HttpService from "@/hooks/Https-services";
import { APIRoutes } from "@/utils/constants";
import useConfig from "@/hooks/useConfig";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTeamContext } from "@/Common/Contex/TeamContext";

const FaviroiteTeam = ({
  userFavoriteTeams,
  teams,
}: {
  userFavoriteTeams: any[];
  teams: any[];
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const configData = useConfig();
  const { setCurrentSelectedTeam, currentSelectedTeam }: any = useTeamContext();

  const [sliderRef, setSliderRef] = useState<any>(null);
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("md"));

  const PreviousBtn = (props: any) => {
    const { className, onClick } = props;
    return (
      <Box
        className={className}
        sx={{ position: "absolute", top: "50%", bottom: "50%" }}
      >
        <IconButton
          onClick={onClick}
          sx={{
            bgcolor: configData.primary,
            border: "1px solid #E7E7E7",
            p: 0.5,
            zIndex: 10,
            ":hover": {
              bgcolor: configData.primary,
            },
          }}
        >
          <ArrowBackIcon
            sx={{ fontSize: "16px", color: configData.tertiary }}
          />
        </IconButton>
      </Box>
    );
  };

  const NextBtn = (props: any) => {
    const { className, onClick } = props;
    return (
      <Box
        className={className}
        sx={{ position: "absolute", top: "50%", bottom: "50%" }}
      >
        <IconButton
          onClick={onClick}
          sx={{
            border: "1px solid #E7E7E7",
            rotate: "180deg",
            p: 0.5,
            bgcolor: configData.primary,
            ":hover": {
              bgcolor: configData.primary,
            },
          }}
        >
          <ArrowBackIcon
            sx={{ fontSize: "16px", color: configData.tertiary }}
          />
        </IconButton>
      </Box>
    );
  };

  const sliderSettings = {
    slidesToShow: isMobile ? 2 : 4,
    autoplay: false,
    autoplaySpeed: 2500,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow:
            userFavoriteTeams?.length > 3 ? 3 : userFavoriteTeams?.length,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (userFavoriteTeams.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body1">No favorite teams found.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2, px: { xs: 0, sm: 2 } }}>
      <Box sx={{ position: "relative", mx: 2 }}>
        <Slider
          ref={setSliderRef}
          {...sliderSettings}
          prevArrow={<PreviousBtn />}
          nextArrow={<NextBtn />}
          dotsClass="slick-dots custom-indicator"
        >
          {userFavoriteTeams.map((team: any) => (
            <Box
              key={team.team_id}
              onClick={() => {
                const findTeam = teams?.find(
                  (t: any) => t?.team_id === team?.team_id
                );
                setCurrentSelectedTeam({
                  firstLetter: "Teams",
                  ...team,
                  ...findTeam,
                });
              }}
              sx={{
                p: 1,
                textAlign: "center",
                bgcolor:
                  currentSelectedTeam?.team_id === team?.team_id
                    ? configData.primary
                    : "",

                borderRadius: "4px",
                cursor: "pointer",

                transition: "transform 0.2s",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              <Box
                sx={{
                  height: 120,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 1,
                }}
              >
                <img
                  src={team.team_logo_url}
                  alt={team.team_name}
                  style={{
                    maxHeight: "100%",
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default FaviroiteTeam;
